import { render, staticRenderFns } from "./Callout.vue?vue&type=template&id=124d2f9e&scoped=true"
import script from "./Callout.vue?vue&type=script&lang=js"
export * from "./Callout.vue?vue&type=script&lang=js"
import style0 from "./Callout.vue?vue&type=style&index=0&id=124d2f9e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124d2f9e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('124d2f9e')) {
      api.createRecord('124d2f9e', component.options)
    } else {
      api.reload('124d2f9e', component.options)
    }
    module.hot.accept("./Callout.vue?vue&type=template&id=124d2f9e&scoped=true", function () {
      api.rerender('124d2f9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/modules/shared/components/display/Callout.vue"
export default component.exports